import React from 'react';
import classNames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';
import { useTranslation } from 'react-i18next';
import PluscircleIcon from 'icons/Pluscircle.icon';
import InputField from 'components/InputField';
import validations from 'validations';

import './Companies.styles.scss';

type CompaniesProps = {
  className?: string;
  maxFields?: number;
};

const Companies: React.FC<CompaniesProps> = (props) => {
  const { className, maxFields = 4 } = props;

  const classes = classNames('companies', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <FieldArray name="directorshipACN">
        {({ fields }) => (
          <>
            {fields.map((name, index) => (
              <div key={name} className="companies__row">
                <Field
                  name={name}
                  component={InputField}
                  placeholder={t('nineDigitLabel')}
                  label={t('acnOfDirectorship')}
                  validate={validations.composeValidators(
                    validations.required(),
                    validations.exactLength(9, t('acnMustHave9Numbers')),
                  )}
                />
                <span />
                {index > 0 && (
                  <Button
                    onClick={() => fields.remove(index)}
                    variant="icon"
                    icon={XIcon}
                    className="remove"
                  />
                )}
              </div>
            ))}

            {fields.length < maxFields && (
              <Button
                variant="link"
                onClick={() => {
                  fields.push(undefined);
                }}
              >
                <PluscircleIcon />
                {t('addAnotherDirectorship')}
              </Button>
            )}
          </>
        )}
      </FieldArray>
    </div>
  );
};

export default Companies;
